import { graphql, type GraphQLTaggedNode } from 'react-relay';

// Keep the focused reader independent of the footer permission-reader kill switch.
export const ViewPageConversationFocusedInlineCommentContextFragment: GraphQLTaggedNode = graphql`
	fragment ViewPageConversation_focusedInlineCommentContext on Query {
		focusedContent: content(id: $pageId) {
			nodes {
				id
				type
				space {
					id
					operations {
						operation
						targetType
					}
				}
				operations {
					operation
					targetType
				}
			}
		}
		user: confluence_atlassianUser(current: true) {
			id
			displayName
			photos {
				value
				isPrimary
			}
		}
	}
`;

export const ViewPageConversationFocusedInlineCommentFragment: GraphQLTaggedNode = graphql`
	fragment ViewPageConversation_focusedInlineComment on PaginatedCommentList {
		nodes {
			ancestors {
				id
				body(representation: ATLAS_DOC_FORMAT) {
					value
				}
				createdAt {
					value
				}
				createdAtNonLocalized
				isInlineComment
				permissions {
					isEditable
					isRemovable
					isResolvable
				}
				version {
					by {
						displayName
					}
					when
					number
				}
				links {
					webui
					editui
				}
				author {
					displayName
					profilePicture {
						path
					}
					permissionType
					... on KnownUser {
						accountId
					}
				}
				replies {
					id
					body(representation: ATLAS_DOC_FORMAT) {
						value
					}
					createdAt {
						value
					}
					createdAtNonLocalized
					isInlineComment
					permissions {
						isEditable
						isRemovable
						isResolvable
					}
					version {
						by {
							displayName
						}
						when
						number
					}
					links {
						webui
						editui
					}
					author {
						displayName
						profilePicture {
							path
						}
						permissionType
						... on KnownUser {
							accountId
						}
					}
				}
			}
			id
			body(representation: ATLAS_DOC_FORMAT) {
				value
			}
			createdAt {
				value
			}
			createdAtNonLocalized
			isInlineComment
			permissions {
				isEditable
				isRemovable
				isResolvable
			}
			version {
				by {
					displayName
				}
				when
				number
			}
			links {
				webui
				editui
			}
			author {
				displayName
				profilePicture {
					path
				}
				permissionType
				... on KnownUser {
					accountId
				}
			}
			replies {
				id
				body(representation: ATLAS_DOC_FORMAT) {
					value
				}
				createdAt {
					value
				}
				createdAtNonLocalized
				isInlineComment
				permissions {
					isEditable
					isRemovable
					isResolvable
				}
				version {
					by {
						displayName
					}
					when
					number
				}
				links {
					webui
					editui
				}
				author {
					displayName
					profilePicture {
						path
					}
					permissionType
					... on KnownUser {
						accountId
					}
				}
			}
		}
	}
`;
